/**
 * The purple *Internal* chip with its lock (Boards 1, 2, 3 B, 4, 7, 8, 16 D,
 * 18 B, 18 E) — the `kind.fee` pair the boards draw. One copy for every slice
 * (lead, Oct 29).
 */
import { COMMON } from './copy.js'
import { VisitGlyph } from './glyphs.js'

export function InternalChip() {
  return (
    <span
      className="inline-flex h-[19px] shrink-0 items-center gap-1 whitespace-nowrap rounded-[4px] px-1.5
                 text-[10.5px] font-bold"
      style={{ color: 'rgb(var(--status-kind-fee-fg))', background: 'rgb(var(--status-kind-fee-bg))' }}
    >
      <VisitGlyph name="lock" size={10} stroke={2.4} />
      {COMMON.internal}
    </span>
  )
}
